module.exports = __webpack_public_path__ + "img/20180803-methow-valley-00008.2a40bafc.jpg";